module.exports = __webpack_public_path__ + "static/media/preview_general_campaign_6.d909a70d.svg";